import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import React from "react";
import SINGLE_PLUGIN_CONTEXT from "src/context/internal/plugin";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "src/components/base/table";

export const Route = createFileRoute("/_admin/a/plugins/$pluginId/_plugin/rulesets")({
    component: RouteComponent,
});

/** Displays a single plugin's rulesets */
function RouteComponent() {
    const [t] = useTranslation("admin-plugin-rulesets");

    const { plugin } = React.useContext(SINGLE_PLUGIN_CONTEXT);

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableHeader>{t("label.name")}</TableHeader>
                    <TableHeader>{t("label.description")}</TableHeader>
                    <TableHeader>{t("label.rule-count")}</TableHeader>
                </TableRow>
            </TableHead>
            <TableBody>
                {plugin.installed
                    ? plugin.rulesets.map((ruleset) => (
                          <TableRow
                              key={ruleset.uuid}
                              href={"/a/rulesets/$rulesetId/rules"}
                              params={{ rulesetId: ruleset.uuid }}
                          >
                              <TableCell>{ruleset.name}</TableCell>
                              <TableCell className={"w-[50ch] text-wrap break-all whitespace-pre-wrap"}>
                                  {ruleset.description}
                              </TableCell>
                              <TableCell>{ruleset.rules.length}</TableCell>
                          </TableRow>
                      ))
                    : plugin.store_version
                      ? plugin.store_version.version_rulesets.map((ruleset) => (
                            <TableRow key={ruleset.uuid}>
                                <TableCell>{ruleset.name}</TableCell>
                                <TableCell className={"w-[50ch] text-wrap break-all whitespace-pre-wrap"}>
                                    {ruleset.description}
                                </TableCell>
                                <TableCell>{ruleset.rules.length}</TableCell>
                            </TableRow>
                        ))
                      : null}
            </TableBody>
        </Table>
    );
}
